import React from 'react';
import Modal from '../../../base/Modal';
import ModalDescription from '../../../base/Modal/ModalDescription';
import ModalFooter from '../../../base/Modal/ModalFooter';
import ModalTitle from '../../../base/Modal/ModalTitle';

const ListConfirmationModal = ({ onCancel, onSubmit, number }) => (
  <Modal>
    <ModalTitle title="Large List" />
    <ModalDescription
      text={`Creating this list will create ${number} new contacts in the CRM. Are you sure you want to proceed?`}
    />
    <ModalFooter>
      <button
        type="button"
        className="outline-button border border-1"
        onClick={() => onCancel()}
      >
        Cancel
      </button>
      <button
        type="button"
        className="regular-button"
        onClick={() => onSubmit()}
      >
        Confirm
      </button>
    </ModalFooter>
  </Modal>
);

export default ListConfirmationModal;
